import React, { Component } from "react";
import styles from "./Presentation.local.scss";

class ProgressBar extends Component {
  render() {
    const { completed } = this.props;
    return (
      <div className={styles.containerStyles}>
        <div className={styles.fillerStyles} style={{ width: `${completed}%` }}>
          <span className={styles.labelStyles} />
        </div>
      </div>
    );
  }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/Presentation/ProgressBar.js